import { render, staticRenderFns } from "./memberBigV.vue?vue&type=template&id=3896f860&scoped=true&"
import script from "./memberBigV.vue?vue&type=script&lang=js&"
export * from "./memberBigV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896f860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3896f860')) {
      api.createRecord('3896f860', component.options)
    } else {
      api.reload('3896f860', component.options)
    }
    module.hot.accept("./memberBigV.vue?vue&type=template&id=3896f860&scoped=true&", function () {
      api.rerender('3896f860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberBigV.vue"
export default component.exports